import axios from "axios";

function getApiToken(): string {
  try {
    const raw = localStorage.getItem("inventory-settings");
    if (raw) {
      const parsed = JSON.parse(raw) as { apiToken?: string };
      if (parsed.apiToken) return parsed.apiToken;
    }
  } catch {
    // ignore
  }
  // Fall back to env var for development convenience, but prefer localStorage for persistence
  return (import.meta.env.VITE_SNIPEIT_TOKEN as string) ?? "";
}

const isDev = import.meta.env.DEV;
const SNIPEIT_BASE_URL = import.meta.env.VITE_SNIPEIT_BASE_URL as string | undefined;

// In dev, use Vite's proxy to bypass self-signed cert issues.
// In prod, call the Snipe-IT API directly (cert is trusted).
const BASE_URL = isDev ? "/snipeit-proxy" : SNIPEIT_BASE_URL;

export const client = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

// Attach the latest token to every request
client.interceptors.request.use((config) => {
  const token = getApiToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** Rewrites a full Snipe-IT image URL to go through the dev proxy, or returns the original path in prod. */
export function proxyImageUrl(url?: string | null): string | null {
  if (!url) return null;
  try {
    const parsed = new URL(url);
    if (isDev) {
      return "/snipeit-proxy" + parsed.pathname + parsed.search;
    }
    return url;
  } catch {
    return null;
  }
}
